<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'billing'" [businessName]="vm.businessName" [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
    <div class="row section-header">
        <div class="col pt-4">Billing</div>
    </div>
    <div>
        <hr class="mt-0 mb-1" />
    </div>

    <div class="row pb-1">
        <div class="col-md-2 font-weight-bold d-flex">
            <div>Period</div>
        </div>
        <div class="col-md-1 font-weight-bold d-flex">
            <div>Device Usage</div>
        </div>
        <div class="col-md-2 font-weight-bold d-flex">
                <div>Manual Usage</div>
            </div>
        <div class="col-md-2 font-weight-bold d-flex">
            <div>EMS</div>
        </div>
        <div class="col-md-2 font-weight-bold d-flex">
            <div>Permit Cost</div>
        </div>
        <div class="col-md-2 font-weight-bold d-flex">
                <div>Total</div>
        </div>
        <div class="col-md-1 font-weight-bold d-flex">
          <div></div>
  </div>
    </div>
    <div>
        <hr class="mt-0 mb-1" />
    </div>
    <div class="row pb-1" *ngFor="let t of vm.items; let i = index" [ngClass]="i%2==0 ? '' : 'bg-light'">
        <div class="col-md-2  text-truncate">{{t.periodName}}</div>
        <div class="col-md-1 text-right pr-5">{{t.deviceCost | currency:false:'symbol':'0.2'}}</div>
        <div class="col-md-2 text-right pr-5">{{t.manualCost | currency:false:'symbol':'0.2'}}</div>
        <div class="col-md-2 text-right pr-5">{{t.emsCost | currency:false:'symbol':'0.2'}}</div>
        <div class="col-md-2  text-right pr-5">{{t.permitCost | currency:false:'symbol':'0.2'}}</div>
        <div class="col-md-2  text-right pr-5">{{t.cost | currency:false:'symbol':'0.2'}}</div>
        <div class="col-md-1 text-right pr-5"><button class="btn btn-link btn-sm" (click)="downloadCsv(t.billingPeriodId)"><i class="fas fa-download"></i> </button></div>

    </div>
    <div class="row" *ngIf="vm.totalCount==0">
        <div class="col">No billing records found</div>
    </div>
    <div *ngIf="vm.totalCount>0">
        <hr class="mt-0 mb-1" />
    </div>
    <div class="row">
        <div class="col pt-2">
            <core-pager [take]="vm.filter.take" [skip]="vm.filter.skip" [totalCount]="vm.totalCount"
                (navigate)="onPage($event)"></core-pager>
        </div>
    </div>
</div>
